import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionSelector, PermissionsService } from './services';

@Injectable()
export class CanLoadPermissionGuard {
  private readonly router = inject(Router);
  private readonly permissionsService = inject(PermissionsService);

  public canLoad(reqRoute: Route): boolean | Observable<boolean> | Promise<boolean> {
    if (!reqRoute.data || !reqRoute.data['permissionGuard']) {
      throw new Error('permissionGuard data attribute must be provided in router config when using CanLoadPermissionGuard');
    }

    const selector = reqRoute.data['permissionGuard'] as PermissionSelector;

    return this.permissionsService.isAllowed(selector).then((allowed) => {
      if (allowed) {
        return true;
      }

      const redirect = selector.routingDeniedRedirect;

      if (redirect) {
        void this.router.navigate([redirect]);
      }

      return false;
    });
  }
}

@Injectable()
export class PermissionGuard {
  private readonly router = inject(Router);
  private readonly permissionsService = inject(PermissionsService);

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!route.data || !route.data['permissionGuard']) {
      throw new Error('permissionGuard data attribute must be provided in router config when using PermissionGuard');
    }

    const selector = route.data['permissionGuard'] as PermissionSelector;

    return this.permissionsService.isAllowed(selector).then((allowed) => {
      if (allowed) {
        return true;
      }

      const redirect = selector.routingDeniedRedirect;

      if (redirect) {
        void this.router.navigate([redirect]);
      }

      return false;
    });
  }
}
